(ns frontend.view.modals.activity-entity-editor.view
  (:require [frontend.state.current-session :as session]
            [frontend.view.entity-viewers.events.note-editor :as note-editor]
            [frontend.view.entity-viewers.events.meeting-editor :as meeting-editor]
            [frontend.view.entity-viewers.events.message-editor :as message-editor]
            [frontend.view.entity-viewers.events.call-editor :as call-editor]
            [frontend.view.entity-viewers.events.email-editor :as email-editor]
            [frontend.view.entity-viewers.events.task-editor :as task-editor]
            [common.localization :as loc]
            [frontend.utils :as fu]
            [ui.util :as uu]
            [ui.components.button.view :as button]))

(defonce modal-key :activity-entity-editor-modal)

(defn view [{:keys [shown? close-modal! props state class-name topmost?]}]
  (let [{:keys [:entity-id entity :viewed-entity-id :new-entity-type :local-entities on-success-callback! custom-delete-button]} props
        externally-passed-entity entity

        entity (cond
                 externally-passed-entity externally-passed-entity

                 local-entities (or (get @local-entities entity-id)
                                    (get @session/entities entity-id))

                 :else (get @session/entities entity-id))

        entity-type (or (:entity/type entity)
                        new-entity-type)                    ;;creating a new entity
        label (or (:title props) (loc/tr (keyword (str "edit-" (if (keyword? entity-type)
                                                             (name entity-type)
                                                             (str entity-type))))))
        viewer (case entity-type
                 :entity.type/note note-editor/note-editor
                 :entity.type/note-meeting meeting-editor/meeting-editor
                 :entity.type/note-message message-editor/message-editor
                 :entity.type/note-call call-editor/call-editor
                 :entity.type/email email-editor/email-editor
                 :entity.type/task task-editor/task-editor
                 nil)]
    (when (and shown? viewer)
      [:div
       {:class (uu/cm "fixed w-full h-full left-0 top-0 flex items-center justify-center bg-black/[.5]"
                           (when-not topmost?
                             "hidden"))}
       [:div
        {:class "max-h-screen md:w-[780px] flex flex-col bg-base-light rounded relative"}
        [:div
         {:class "p-3 flex items-center justify-between border-b border-solid border-base-light-border-paler"}
         [:h2
          {:class "text-base-light-text text-xl font-bold"}
          label]
         [:div 
          {:class "*:p-0"}
          [button/secondary-open
           {:on-click (fn [_]
                        (close-modal!))}
           [:i.fal.fa-times]]]]
        [:div
         {:class "flex-1  w-full overflow-auto"}
         [viewer {:state            state
                  :modal?           true
                  :entity-id        entity-id
                  :externally-passed-entity externally-passed-entity
                  :viewed-entity-id viewed-entity-id
                  :show-expanded?   true
                  :on-success-callback! on-success-callback!
                  :custom-delete-button custom-delete-button
                  :on-reset!        (fn [_]
                                      (close-modal!))
                  :props            props}]]]])))
